import axios from 'axios';
import { fromBuffer } from 'file-type';

import getExtensionFromFileName from '@app/libs/file/getExtensionFromFileName';
import { checkIsUploadedFileValid } from '@app/store/transport-layer/document/documents/file-hashes';
import { reservePDFUploadUrl } from '@app/store/transport-layer/document/documents/file-hashes/upload-url';

import { UPLOAD_FILE_BYTE } from '../../constants';

export default async function uploadFile(file: File): Promise<{
  fileId: string;
  otp: string;
}> {
  await validateFile(file);

  const { fileId, otp, presignedPostUrlResult } = await reservePDFUploadUrl();

  const formData = new FormData();
  Object.entries(presignedPostUrlResult.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });

  formData.append('file', file);

  await axios.post(presignedPostUrlResult.url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  await checkIsUploadedFileValid(fileId, otp);

  return {
    fileId,
    otp,
  };
}

async function validateFile(file: File) {
  // 파일에 접근 가능한지 확인.

  const arrayBuffer = await file.arrayBuffer();

  const ext = (await fromBuffer(arrayBuffer))?.ext ?? getExtensionFromFileName(file.name).slice(1);

  if (ext !== 'pdf') {
    throw new Error('Such ext is not allowed');
  }

  if (UPLOAD_FILE_BYTE < file.size) {
    throw new Error('File size exceed max');
  }
}
